import { useMemo, useState } from "react";
import { toast } from "sonner";
import { Copy, ExternalLink } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/common/Common";
import { ChannelAssistant } from "@/components/channels/ChannelAssistant";

export default function WhatsAppChannel() {
  const [phone, setPhone] = useState("");
  const [msg, setMsg] = useState("Olá! Vi seu anúncio e gostaria de mais informações.");
  const digits = phone.replace(/\D/g, "");
  const valid = digits.length >= 12 && digits.length <= 13;
  const link = useMemo(() => (valid ? `https://wa.me/${digits}?text=${encodeURIComponent(msg)}` : ""), [digits, msg, valid]);
  const copy = () => { navigator.clipboard.writeText(link); toast.success("Link copiado"); };
  return (
    <div className="space-y-4" data-testid="whatsapp-channel">
      <PageHeader eyebrow="Canais de Anúncios" title="WhatsApp Business" desc="Gere links de conversa, textos comerciais e anúncios com destino ao WhatsApp." />
      <div className="grid lg:grid-cols-2 gap-3 items-start">
        <section className="surface p-4 space-y-3">
          <p className="font-semibold">Gerador de link wa.me</p>
          <div><Label>Número com DDI e DDD</Label><Input placeholder="55 11 91234-5678" value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="wa-phone-input" />
            {phone && !valid && <p className="text-xs text-[#EA4335] mt-1">Use o formato 55 + DDD + número (12 ou 13 dígitos).</p>}</div>
          <div><Label>Mensagem inicial</Label><Textarea rows={3} value={msg} onChange={(e) => setMsg(e.target.value)} data-testid="wa-message-input" /></div>
          {link && <div className="flex gap-2"><Input readOnly value={link} className="font-mono text-xs" data-testid="wa-link-output" />
            <Button variant="outline" onClick={copy} data-testid="wa-copy-button"><Copy className="h-4 w-4" /></Button>
            <Button variant="outline" asChild><a href={link} target="_blank" rel="noreferrer" data-testid="wa-open-link"><ExternalLink className="h-4 w-4" /></a></Button></div>}
        </section>
        <section className="surface p-4 space-y-2 text-sm">
          <p className="font-semibold">Anúncios com destino ao WhatsApp</p>
          <p className="text-muted-foreground">No Facebook e no Instagram, crie em <b>Canais &gt; Facebook Ads</b> uma campanha com objetivo <b>Conversas no WhatsApp</b>. Ela é criada pausada pela Meta Marketing API e você ativa no Gerenciador de Anúncios.</p>
          <p className="text-muted-foreground">No Google Ads e no YouTube, use o link wa.me acima como URL final do anúncio.</p>
          <p className="text-xs text-muted-foreground">Requisito da Meta: sua Página do Facebook precisa estar vinculada a um número do WhatsApp Business.</p>
        </section>
      </div>
      <ChannelAssistant channel="whatsapp" label="WhatsApp" />
    </div>
  );
}
